(() => {
  const BUNDLE_VARIANT_ID = '58306376335734';
  const VARIANT_ID_MAP = {
    '58302910660982': '58306376270198',
    '58303007129974': '58306376335734',
    '58303006933366': '58306376401270',
    '58303006736758': '58306376434038'
  };
  const EVENT_FIELDS = {
    'properties[Eventnamn]': 'KUF Gävle – Kickoff Event',
    'properties[Eventdatum]': '16 augusti 2026',
    'properties[Eventtid]': 'Från 16:00',
    'properties[Eventplats]': 'Restaurang Villa Skeppsbron, Södra Skeppsbron 13, Gävle',
    'properties[Digital leverans]': 'Min sida och e-post'
  };

  const remapVariantIds = (scope = document) => {
    if (!scope || typeof scope.querySelectorAll !== 'function') return;

    scope.querySelectorAll('input[name="id"]').forEach((input) => {
      const currentId = String(input.value || '');
      if (VARIANT_ID_MAP[currentId]) input.value = VARIANT_ID_MAP[currentId];
    });

    scope.querySelectorAll('[data-variant-id]').forEach((element) => {
      const currentId = String(element.dataset.variantId || '');
      if (VARIANT_ID_MAP[currentId]) element.dataset.variantId = VARIANT_ID_MAP[currentId];
    });
  };

  const createTicketId = () => {
    let randomPart = Math.random().toString(36).slice(2, 10).toUpperCase();
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      randomPart = window.crypto.randomUUID().split('-')[0].toUpperCase();
    }
    return `KUF-${Date.now().toString(36).toUpperCase()}-${randomPart}`;
  };

  const createHidden = (form, name, value = '') => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    input.disabled = true;
    form.appendChild(input);
    return input;
  };

  const initialise = (root) => {
    if (!root || root.dataset.kufBundleTicketReady === 'true') return;
    root.dataset.kufBundleTicketReady = 'true';
    const form = root.querySelector('form');
    if (!form) return;

    remapVariantIds(form);

    const bundleOption = form.querySelector(`[data-kuf-package][data-variant-id="${BUNDLE_VARIANT_ID}"]`);
    if (!bundleOption) return;

    const ticketId = createHidden(form, 'properties[Biljett-ID]');
    const ticketType = createHidden(form, 'properties[Biljettyp]', 'Medlemskap + kickoff');
    const extraFields = Object.entries(EVENT_FIELDS).map(([name, value]) => createHidden(form, name, value));
    const holder = createHidden(form, 'properties[Biljettinnehavare]');
    const nameInput = form.querySelector('input[name="properties[För- och efternamn]"]');

    const sync = () => {
      remapVariantIds(form);
      const selected = form.querySelector('[data-kuf-package]:checked');
      const isBundle = selected && String(selected.dataset.variantId) === BUNDLE_VARIANT_ID;
      [ticketId, ticketType, holder, ...extraFields].forEach((field) => { field.disabled = !isBundle; });
      if (isBundle) {
        if (!ticketId.value) ticketId.value = createTicketId();
        holder.value = nameInput ? nameInput.value.trim() : '';
      } else {
        ticketId.value = '';
        holder.value = '';
      }
    };

    form.querySelectorAll('[data-kuf-package]').forEach((option) => {
      option.addEventListener('change', sync);
      option.addEventListener('input', sync);
    });
    if (nameInput) nameInput.addEventListener('input', sync);
    form.addEventListener('submit', sync, true);
    sync();
  };

  const start = () => {
    remapVariantIds(document);
    document.querySelectorAll('[data-kuf-payment-root]').forEach(initialise);
  };

  document.addEventListener('submit', (event) => {
    remapVariantIds(event.target);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
